import React, { useState } from 'react';
import TooltipContent from './TooltipContent';
import { TooltipWrapper, HoverElement } from './Tooltip.styles';

type OwnProps = {
  children: React.ReactElement[];
  className?: string;
  persist?: boolean;
};

export default function Tooltip({ children, className, persist }: OwnProps) {
  const [show, showTooltip] = useState(false);
  const [position, setPosition] = useState<
    | {
        rect: DOMRect;
        scrollLeft: number;
        scrollTop: number;
      }
    | undefined
  >();

  const onEnter = (e: React.MouseEvent, force: boolean) => {
    if (show) return;
    if (persist && !force) return;
    try {
      const el = e.target as HTMLElement;
      const rect = el.getBoundingClientRect();
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      const scrollLeft = document.body.scrollLeft || document.documentElement.scrollLeft;
      setPosition({
        rect,
        scrollTop,
        scrollLeft
      });

      showTooltip(true);
    } catch (err) {
      // do nothing on error
    }
  };

  const blockClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const closeTooltip = (_: React.MouseEvent, force: boolean) => {
    if (persist && !force) return;
    showTooltip(false);
  };

  const closeTooltipOnX = () => {
    showTooltip(false);
  };

  return (
    <TooltipWrapper
      onClick={blockClick}
      onMouseEnter={onEnter}
      onTouchStart={onEnter}
      onMouseLeave={closeTooltip}
      onMouseDown={(e: React.MouseEvent) => onEnter(e, true)}
      className={className}
    >
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          show,
          position,
          showTooltip,
          closeTooltipOnX
        })
      )}
    </TooltipWrapper>
  );
}

Tooltip.Content = TooltipContent;
Tooltip.HoverElement = HoverElement;
